<template>
  <b-container>
    <li
      v-for="(section, sectionName) in config"
      v-show="true"
      :key="sectionName"
      class="list-group-item">
      <span
        v-b-toggle="sectionName"
        class="pointer">
        <i class="fa fa-comments" />
        {{ sectionName }}
      </span>
      <i
        class="fa fa-times close"
        @click="confirmRemoval({ id: sectionName }, () => removeSection(sectionName))" />
      <b-collapse :id="sectionName">
        <div>
          <li
            v-for="(message, messageKey) in section"
            :key="messageKey"
            class="list-group-item">
            <span
              v-b-toggle="messageKey"
              class="pointer">
              <i class="fa fa-key" />
              {{ messageKey }}
            </span>
            <i
              class="fa fa-times close"
              @click="confirmRemoval({ id: messageKey }, () => removeMessageKey(section, messageKey))" />
            <b-collapse :id="messageKey">
              <component
                :is="getComponentName(messageKey)"
                :message="message"
                :message-key="messageKey"
                class="mt-3"
                @add-event-map-item="onAddEventMapItem"
                @remove-event-map-item="onRemoveEventMapItem" />
            </b-collapse>
          </li>
          <b-row align-h="end">
            <b-col
              class="mt-3 mb-3"
              cols="auto">
              <b-button
                variant="outline-primary"
                @click="addMessageKey(section, true)">
                Add Message
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-collapse>
    </li>
    <b-row align-h="end">
      <b-col
        class="mt-3 mb-3"
        cols="auto">
        <b-button
          variant="outline-primary"
          @click="addSection()">
          Add Section
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import MessageKey from "@/components/Messages/MessageKey"
import EventMap from "@/components/Messages/EventMap"
import ConfirmRemoval from '@/mixins/ConfirmRemoval'

export default {
  name: "MessageFormVue",
  components: {
    EventMap,
    MessageKey,
  },
  mixins: [ConfirmRemoval],
  props: {
    config: {
      type: Object,
      default: null,
    },
  },
  methods: {
    getComponentName(messageKey) {
      if (messageKey === "eventMap") {
        return 'EventMap'
      }
      return 'MessageKey'
    },
    addSection() {
      const name = prompt("Please enter a name for the section", "SectionKey")
      if (name) {
        this.$set(this.config, name, {})
      }
    },
    removeSection(section) {
      this.$delete(this.config, section)
    },
    addMessageKey(parent) {
      const name = prompt("Please enter a name for the message", "MessageKey")
      if(name) {
        const message = {
          isActive: false,
          type: "",
          autoDismiss: 0,
          delay: 0,
          targetedUserType: "",
          buttonLinkUrl: "",
          buttonLabel: "",
          linkNewWindow: false,
          body: "",
          isModal: false,
          template: "",
          title: "",
          subtitle: "",
          description: "",
          link: {
            target: "_blank",
            text: "",
          },
          button: {
            action: "_blank",
            style: {
              color: "",
              backgroundColor: "",
              padding: "",
            },
            linkNewWindow: "",
            label: "",
            link: "",
            iconName: "",
          },
          delayBetween: 0,
        }

        this.$set(parent, name, message)
        return true
      }
      return false
    },
    removeMessageKey(section, messageKey) {
      this.$delete(section, messageKey)
    },
    onAddEventMapItem(eventName) {
      const event = {
        unentitledMessageKey: "",
        entitledMessageKey: "",
      }
      this.$set(this.config.account.eventMap, eventName, event)
    },
    onRemoveEventMapItem(eventName) {
      this.$delete(this.config.account.eventMap, eventName)
    },
  },
}
</script>

<style scoped>

</style>